module.exports = __webpack_public_path__ + "img/cash-recap.3caa6a08.png";